import type { RestrictionSilence } from '@cast/types';

/**
 * Fixtures for the optimization-constraints suppression (silencing) APIs,
 * served by the `mockRestrictionSilences` Dev Toolbox override. Types are the
 * OpenAPI `RestrictionSilence` model; empty filter fields are wildcards.
 */

const createMockRestrictionSilence = (
  overrides: Partial<RestrictionSilence> = {}
): RestrictionSilence => ({
  silenceId: 'silence-1',
  workloadName: 'web-frontend',
  workloadKind: 'Deployment',
  namespace: 'default',
  restrictionType: 'missing_probes',
  affectedWorkloads: '2',
  comment: 'Noisy during rollout',
  createdBy: 'user-1',
  createTime: '2026-10-21T10:30:00Z',
  ...overrides,
});

const MOCK_RESTRICTION_SILENCES: RestrictionSilence[] = [
  createMockRestrictionSilence(),
  createMockRestrictionSilence({
    silenceId: 'silence-2',
    workloadName: 'redis-master',
    workloadKind: 'StatefulSet',
    namespace: 'databases',
    restrictionType: '',
    affectedWorkloads: '1',
    comment: '',
  }),
  createMockRestrictionSilence({
    silenceId: 'silence-3',
    // Empty fields are wildcards ("all X")
    workloadName: '',
    workloadKind: '',
    namespace: 'ingress',
    restrictionType: '',
    affectedWorkloads: '12',
    comment: 'Temporary silencing while migrating',
  }),
];

export const MOCK_RESTRICTION_SILENCES_RESPONSE = {
  silences: MOCK_RESTRICTION_SILENCES,
};

export const MOCK_CREATE_RESTRICTION_SILENCE_RESPONSE =
  createMockRestrictionSilence({
    silenceId: 'silence-new',
    affectedWorkloads: '33',
  });

export const MOCK_PREVIEW_RESTRICTION_SILENCE_RESPONSE = {
  affectedWorkloads: '33',
};
